import React, { useEffect } from 'react'
import {
  PMPHeaderDoctorText,
  PMPHeaderLeftPart,
  PMPHeaderRightPart,
  PMPHeadingBanner,
} from 'src/mentor/components/PrescriptionMakingPage/PrescriptionMakingPageStyles'
import PrescriptionKVItem from 'src/mentor/components/PrescriptionMakingPage/prescriptionTemplate/common/PrescriptionKVItem'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import { ensureNotoSansDevanagariLoaded } from 'src/utils/loadOnDemandFonts'

export default function ManasthanPrescriptionHeader({
  prescriptionData,
  leaveSpace,
  debug = false,
  topPadding = '2px',
}) {
  const currentLayout = prescriptionData?.layout

  useEffect(() => {
    ensureNotoSansDevanagariLoaded()
  }, [])

  // PRESCRIPTION_LAYOUTS.listPointersFooter

  return (
    <>
      {/* <PMPHeadingBanner
        debug={debug}
        noColor={true}
        style={{
          paddingTop: topPadding,
          flexDirection: 'row',
          justifyContent: 'center',
          letterSpacing: '0px',
          gap: '16px',
        }}
      >
        <div
          className="d-flex flex-column"
          style={{ fontFamily: "'Noto Sans Devanagari'", fontSize: '16px' }}
        >
          {prescriptionData?.header?.subTitle && (
            <span className="sub-heading" style={{ fontSize: '1em' }}>
              {prescriptionData?.header?.subTitle}
            </span>
          )}
        </div>
        <div style={{ aspectRatio: 1, width: '50px' }}></div>
      </PMPHeadingBanner> */}

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '2fr 1fr 2fr',
          //   justifyContent: 'space-between',
        }}
      >
        <PMPHeaderLeftPart style={{ width: '100%' }}>
          {prescriptionData?.otherDoctorInfos?.map((info, idx) => (
            <DoctorContainer
              key={idx}
              layoutType={currentLayout}
              doctorName={info?.doctorName}
              designation={info?.designation}
              listOfDegrees={info?.listOfDegrees}
              regId={info?.regId}
              contactEmail={info?.contactEmail}
              website={info?.website}
              cmoRegId={info?.cmoRegId}
              affiliations={info?.affiliations}
              doctorOtherDetails={info?.doctorOtherDetails}
            />
          ))}

          {/* <DoctorContainer
            layoutType={currentLayout}
            doctorName={prescriptionData?.doctorName}
            designation={prescriptionData?.designation}
            listOfDegrees={prescriptionData?.listOfDegrees}
            regId={prescriptionData?.regId}
            contactEmail={prescriptionData?.contactEmail}
            website={prescriptionData?.website}
            cmoRegId={prescriptionData?.cmoRegId}
            affiliations={prescriptionData?.affiliations}
            doctorOtherDetails={prescriptionData?.doctorOtherDetails}
          /> */}
        </PMPHeaderLeftPart>
        <div
          style={{
            aspectRatio: 1,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {!!prescriptionData?.clinicBrandLogo && (
            <img
              style={{ width: '80%', height: '80%' }}
              src={getImageLink(prescriptionData?.clinicBrandLogo)}
              alt="clinicBrandLogo"
            ></img>
          )}
        </div>
        <PMPHeaderRightPart
          style={{
            flexShrink: 0,
            width: '100%',
            textAlign: 'right',
          }}
        >
          {prescriptionData?.header?.title && (
            <div
              style={{
                // border: '2px solid #000',
                // borderRadius: '8px',
                padding: '0 24px',
                fontSize: '1.8em',
                fontWeight: '900',
              }}
            >
              <span>{prescriptionData?.header?.title}</span>
            </div>
          )}
          <PMPHeaderDoctorText>{prescriptionData?.contactAddress}</PMPHeaderDoctorText>
          <PMPHeaderDoctorText>Ph.No.: {prescriptionData?.contactNumber}</PMPHeaderDoctorText>
          <PMPHeaderDoctorText>Email: {prescriptionData?.contactEmail}</PMPHeaderDoctorText>
          <PMPHeaderDoctorText>CMO Regn No.: {prescriptionData?.cmoRegId}</PMPHeaderDoctorText>
        </PMPHeaderRightPart>
      </div>
    </>
  )
}

function DoctorContainer({ doctorName, listOfDegrees }) {
  return (
    <>
      <PMPHeaderDoctorText
        main
        style={{
          fontSize: 'unset',
          width: '100%',
        }}
      >
        <span style={{ fontSize: '1em', fontWeight: '900' }}>
          {doctorName} ({listOfDegrees?.join(', ')})
        </span>
      </PMPHeaderDoctorText>
      {/* {regId && (
        <PMPHeaderDoctorText>
          <PrescriptionKVItem
            itemKey="Regn No."
            topContainerProps={{
              className: 'd-flex align-items-center gap-1',
            }}
            value={regId}
          />
        </PMPHeaderDoctorText>
      )}
      {contactEmail && (
        <PMPHeaderDoctorText>
          <PrescriptionKVItem
            itemKey="Email"
            topContainerProps={{
              className: 'd-flex align-items-center gap-1',
            }}
            value={contactEmail}
          />
        </PMPHeaderDoctorText>
      )}
      {website && (
        <PMPHeaderDoctorText>
          <PrescriptionKVItem
            itemKey="Website"
            topContainerProps={{
              className: 'd-flex align-items-center gap-1',
            }}
            value={website}
          />
        </PMPHeaderDoctorText>
      )}
      {cmoRegId && (
        <PMPHeaderDoctorText>
          <PrescriptionKVItem
            itemKey="C.M.O. Regd. No."
            topContainerProps={{
              className: 'd-flex align-items-center gap-1',
            }}
            value={cmoRegId}
          />
        </PMPHeaderDoctorText>
      )}
      {affiliations?.map((affiliation, affIndex) => (
        <PMPHeaderDoctorText key={affIndex}>
          <b>{affiliation}</b>
        </PMPHeaderDoctorText>
      ))}
      {doctorOtherDetails?.map((detail, detailIndex) => (
        <PMPHeaderDoctorText className="fw-light" key={detailIndex}>
          <b>{detail}</b>
        </PMPHeaderDoctorText>
      ))} */}
    </>
  )
}
